export type EstimatesFilter = 'review' | 'mine' | 'all';

export const ESTIMATE_FILTERS: readonly EstimatesFilter[] = ['review', 'mine', 'all'];

export interface EstimatesSearch {
  readonly filter?: EstimatesFilter | undefined;
}

/** Фильтр списка смет из адреса: неизвестное значение отбрасывается. */
export function parseEstimatesSearch(search: Record<string, unknown>): EstimatesSearch {
  const filter = ESTIMATE_FILTERS.find((own) => own === search.filter);
  return filter === undefined ? {} : { filter };
}
